import '../css/main.css';
import 'virtual:auto-styles';
import 'virtual:auto-scripts';

import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'

// Register Alpine plugins
Alpine.plugin(collapse)

// Make Alpine available globally
window.Alpine = Alpine

// Start Alpine
Alpine.start()

// Helpers
// import './helpers/example.js';


